import HttpClient from "../client/httpclient";
import Loader from "../loading/loader";
import 'regenerator-runtime/runtime';

class DynamicFilter {
    constructor(DOMelement) {
        try {
            this.el = DOMelement.parentElement;
            this.input = this.el.querySelector(".sd-input");
            this.button = this.el.querySelector("button");
            this.results = DOMelement;
            this.loaderEl = document.querySelector(".sd-searchbar > .sd-loading");
            this.loader = new Loader(this.loaderEl);

            this.filtersContainer = this.el.querySelector("#filters-container-desktop");
            this.selectedFiltersContainer = this.el.querySelector("#selected-filters1");
            this.selectedFiltersMobileContainer = this.el.querySelector("#selected-filters");
            this.filtersContainerMobile = this.el.querySelector("#filters-container");

            const filterDrawer = this.el.querySelector("#filter-drawer");
            const openFiltersBtn = this.el.querySelector("#open-filters-btn");
            const closeFiltersBtn = this.el.querySelector("#close-filters-btn");
            this.applyFiltersBtn = this.el.querySelector("#apply-filters-btn");
            this.dynamicFilterApiUrl = this.el.querySelector("#dynamicFilterApiUrl");
            this.dynamicFilterDataUrl = this.dynamicFilterApiUrl.getAttribute("data-dynamic-filters");
            this.dynamicFilterListUrl = this.dynamicFilterApiUrl.getAttribute("data-action-dynamic-filter");
            this.dynamicFilterDsId = this.dynamicFilterApiUrl.getAttribute("data-dsId");
            this.dynamicFilterPageId = this.dynamicFilterApiUrl.getAttribute("data-pageId");

            this.currentPageNumber = 2;

            if (process.env.NODE_ENV === "development") {
                this.URL = '../src/components/room-card/room-card.html?p=';
            }

            this.el.querySelectorAll(".load-more-filter-button button").forEach(button => {
                button.addEventListener("click", (event) => {
                    event.preventDefault();
                    this.loadMoreResults(button);
                });
                this.URL = button.getAttribute("data-action");
            });

            this.headers = document.querySelectorAll(".filter-group h4");
            this.removeFilterBtn = document.querySelectorAll(".remove-filter");

            this.updateSelectedFilters = this.updateSelectedFilters.bind(this);
            this.handleFilterChange = this.handleFilterChange.bind(this);
            this.selectedFiltersGloblal;

            // Open drawer on mobile
            openFiltersBtn.addEventListener("click", () => {
                filterDrawer.classList.add("open");
            });

            // Close drawer on mobile
            closeFiltersBtn.addEventListener("click", () => {
                filterDrawer.classList.remove("open");
            });

            this.applyFiltersBtn.addEventListener("click", () => {
                this.updateSelectedMobileFilters();
                this.callApiWithSelectedFilters();
                filterDrawer.classList.remove("open");
            });

            this.removeFilterBtn.forEach(el => {
                el.addEventListener("click", function () {
                    filter.checkbox.checked = false;
                    this.handleFilterChange();
                });
            });

            this.method = "GET";
            this.url = this.dynamicFilterDataUrl;
            this.listUrl = this.dynamicFilterListUrl;

            this.getFilterData();

            this.noResultFlag = 0;
            this.noResultContent = "";
            this.noPropTourMessage = "";

        } catch (error) {
            console.log(error);
        }
    }
    //are the element for the filters built the same way as cruise otherwise can clean 
    createFilters(filters) {
        if (filters.length > 0) {
            filters.forEach((filter) => {
                const filterGroup = document.createElement("div");
                filterGroup.className = "filter-group";
                filterGroup.dataset.group = filter.Name;

                const dropdown = document.createElement("div");
                dropdown.className = "dropdown";

                const dropdownBtn = document.createElement("button");
                dropdownBtn.className = "dropdown-btn";
                dropdownBtn.textContent = filter.Name;

                const filterCountElement = document.createElement("span");
                filterCountElement.className = `filter-count ${filter.Name.replace(/\s+/g, '')}`;
                dropdownBtn.appendChild(filterCountElement);

                const dropdownContent = document.createElement("div");
                dropdownContent.className = "dropdown-content";

                filter.Options.forEach((option) => {
                    const label = document.createElement("label");
                    const checkbox = document.createElement("input");
                    const labelName = document.createElement("span");
                    checkbox.type = "checkbox";
                    checkbox.className = "filter-checkbox";
                    checkbox.value = option;
                    checkbox.dataset.displayValue = option;
                    checkbox.dataset.filterName = filter.Name.replace(/\s+/g, '');
                    checkbox.addEventListener("change", this.handleFilterChange);
                    labelName.appendChild(document.createTextNode(option))
                    label.appendChild(checkbox);
                    label.appendChild(labelName);
                    dropdownContent.appendChild(label);
                });

                dropdown.appendChild(dropdownBtn);
                dropdown.appendChild(dropdownContent);
                filterGroup.appendChild(dropdown);
                this.filtersContainer.appendChild(filterGroup);
            });
            this.el.querySelectorAll('.dropdown-btn').forEach(button => {
                button.addEventListener('click', function () {
                    const dropdownContent = this.nextElementSibling;
                    const parent = this.closest(".filter-group");
                    document.querySelectorAll('.dropdown-content').forEach(content => {
                        if (content !== dropdownContent) {
                            content.closest(".filter-group").classList.remove('active');
                            content.style.display = 'none';
                        }
                    });

                    if (dropdownContent.style.display === 'block') {
                        dropdownContent.style.display = 'none';
                        parent.classList.remove('active');
                    } else {
                        dropdownContent.style.display = 'block';
                        parent.classList.add('active');
                    }
                });
            });
            this.el.addEventListener('click', function (event) {
                if (!event.target.closest('.filter-group')) {
                    const dropdowns = document.querySelectorAll('.dropdown-content');
                    const parentsdropDowns = document.querySelectorAll('.filter-group');
                    dropdowns.forEach(dropdown => {
                        dropdown.style.display = 'none';
                    });
                    parentsdropDowns.forEach(parentsdropDowns => {
                        parentsdropDowns.classList.remove('active');
                    });
                }
            });
        } else {
            this.el.querySelector(".on-site-filter")?.remove();
        }
        this.updateResultsLine();
    }

    createMobileFilters(filters) {
        filters.forEach((filter) => {
            const filterGroup = document.createElement("div");
            filterGroup.className = "filter-group";
            filterGroup.dataset.group = filter.Name;

            const filterTitle = document.createElement("h4");
            filterTitle.textContent = filter.Name;
            filterTitle.addEventListener("click", function () {
                const dropdownContent = this.nextElementSibling;
                const parent = this.closest(".filter-group");

                document.querySelectorAll('.filter-group-content').forEach(content => {
                    if (content !== dropdownContent) {
                        content.closest(".filter-group").classList.remove('active');
                        content.style.maxHeight = 0;
                    }
                });
                if (parent.classList.contains('active')) {
                    parent.classList.remove('active');
                    dropdownContent.style.maxHeight = 0;
                } else {
                    parent.classList.add('active');
                    let elHeight = dropdownContent.scrollHeight;
                    dropdownContent.style.maxHeight = elHeight + 'px';

                }
            });

            filterGroup.appendChild(filterTitle);
            const filterWrapper = document.createElement("div");
            filterWrapper.className = 'filter-group-content';
            filterGroup.appendChild(filterWrapper);

            filter.Options.forEach((option) => {
                const label = document.createElement("label");
                const checkbox = document.createElement("input");
                checkbox.type = "checkbox";
                checkbox.className = "filter-checkbox";
                checkbox.value = option;
                checkbox.dataset.displayValue = option;
                checkbox.dataset.filterName = filter.Name.replace(/\s+/g, '');
                checkbox.addEventListener("change", this.handleFilterChange);

                label.appendChild(checkbox);
                label.appendChild(document.createTextNode(option));
                filterWrapper.appendChild(label);
            });
            this.filtersContainerMobile.appendChild(filterGroup);
        });
    }

    updateResultsLine(totalresultsFromAPI) {
        // Number of results functionality
        let finalCount = this.el.querySelectorAll(".itinerary-list__content__tour-list").length;
        if (this.el.querySelectorAll(".page-number-OSS")) {
            this.el.querySelectorAll('.page-number-OSS').forEach(e => e.remove());
        }

        const pageNumberOSS = document.createElement("div");
        pageNumberOSS.classList.add("page-number-OSS");
        if (totalresultsFromAPI) {
            var totalResults = totalresultsFromAPI;
        } else {
            var totalResults = this.dynamicFilterApiUrl.getAttribute("data-totalresults");
        }
        let resultsString = totalResults > 1 ? 'results' : 'result';
        pageNumberOSS.innerHTML = `1 - ${finalCount} of ${totalResults}  ${resultsString} `;
        var child1 = document.querySelector('.on-site-filter');
        this.el.querySelector('.dynamicFilter').appendChild(pageNumberOSS, child1);
        var pageNumberOSS1 = pageNumberOSS.cloneNode(true);
        this.el.querySelector('.product__container').appendChild(pageNumberOSS1);
        // Number of results functionality
    }

    handleFilterChange() {
        this.updateSelectedFilters();
        this.updateUrlWithFilters();
        this.callApiWithSelectedFilters();
    }

    updateSelectedFilters() {
        this.el.querySelector("#selected-filters1").innerHTML = ""; // Clear previous selected filters

        const checkboxes = this.el.querySelectorAll(".filter-checkbox");
        const selectedFilters = Array.from(checkboxes)
            .filter((checkbox) => checkbox.checked)
            .map((checkbox) => ({
                name: checkbox.dataset.filterName,
                value: checkbox.value,
                checkbox: checkbox,
                path: `${checkbox.dataset.filterName}=${checkbox.value}`,
                displayValue: `${checkbox.dataset.displayValue}`
            }));
        this.selectedFiltersGloblal = selectedFilters;

        selectedFilters.forEach((filter) => {
            const filterTag = document.createElement("div");
            filterTag.className = "selected-filter";

            const filterName = document.createElement("span");
            filterName.textContent = `${filter.displayValue}`;

            const removeBtn = document.createElement("span");
            removeBtn.className = "remove-filter";
            removeBtn.textContent = "x";

            removeBtn.addEventListener("click", function () {
                filter.checkbox.checked = false;
            });
            removeBtn.addEventListener("click", this.handleFilterChange.bind(this));

            filterTag.appendChild(filterName);
            filterTag.appendChild(removeBtn);
            this.el.querySelector("#selected-filters1").appendChild(filterTag);
            this.countSelectedFilters(selectedFilters);
        });

        if (selectedFilters.length === 0) {
            const allFilters = this.el.querySelectorAll(".filter-count");
            allFilters.forEach(filter => {
                filter.style.display = "none"
            })
        }
    }

    countSelectedFilters(filters) {
        const counts = {};
        filters.forEach(filter => {
            if (!counts[filter.name.replace(/\s+/g, '')]) {
                counts[(filter.name).replace(/\s+/g, '')] = 0;
            }
            counts[(filter.name).replace(/\s+/g, '')]++;
        });

        const allFilters = this.el.querySelectorAll(".filter-count");
        allFilters.forEach(filter => {
            filter.style.display = "none"
        })

        var currentElement = this.el; // required as the following forEach contains a Regular Function which makes it's own "this" state, without the .el field.
        Object.keys(counts).forEach(function (key) {
            currentElement.querySelector(`.${key}`).textContent = `${counts[key]}`;
            if (counts[key] == 0) {
                currentElement.querySelector(`.${key}`).style.display = "none";
            } else {
                currentElement.querySelector(`.${key}`).style.display = "inline-flex";
            }
        });
    }

    updateSelectedMobileFilters() {
        this.el.querySelector("#selected-filters").innerHTML = ""; // Clear previous selected filters

        const checkboxes = this.el.querySelectorAll(".filter-checkbox");
        const selectedFilters = Array.from(checkboxes)
            .filter((checkbox) => checkbox.checked)
            .map((checkbox) => ({
                name: checkbox.dataset.filterName,
                value: checkbox.value,
                checkbox: checkbox,
                path: `${checkbox.dataset.filterName}=${checkbox.value}`,
                displayValue: `${checkbox.dataset.displayValue}`
            }));
        this.selectedFiltersGloblal = selectedFilters;

        selectedFilters.forEach((filter) => {
            const filterTag = document.createElement("div");
            filterTag.className = "selected-filter";

            const filterName = document.createElement("span");
            filterName.textContent = `${filter.displayValue}`;

            const removeBtn = document.createElement("span");
            removeBtn.className = "remove-filter";
            removeBtn.textContent = "x";
            removeBtn.addEventListener("click", function () {
                filter.checkbox.checked = false;
            });
            removeBtn.addEventListener("click", this.handleFilterChange.bind(this));

            removeBtn.addEventListener("click", this.callApiWithSelectedFilters.bind(this));
            removeBtn.addEventListener("click", this.updateSelectedMobileFilters.bind(this));

            filterTag.appendChild(filterName);
            filterTag.appendChild(removeBtn);
            this.el.querySelector("#selected-filters").appendChild(filterTag);
        });

        if (selectedFilters.length === 0) {
            const allFilters = this.el.querySelectorAll(".filter-count");
            allFilters.forEach(filter => {
                filter.style.display = "none"
            })
        }
    }

    // Function to get the selected category
    getSelectedCategory() {
        const radioButtons = document.querySelectorAll('.sd-tabs input[type="radio"]');
        const selectedRadio = Array.from(radioButtons).find(radio => radio.checked);
        return selectedRadio ? selectedRadio.dataset.category : null;
    }

    async callApiWithSelectedFilters() {
        const currentPage = 1;

        const checkboxes = this.el.querySelectorAll(".filter-checkbox");
        const selectedFilters = Array.from(checkboxes)
            .filter((checkbox) => checkbox.checked)
            .map((checkbox) => ({
                name: checkbox.dataset.filterName,
                value: checkbox.value,
            })).reduce((acc, { name, value }) => {
                if (!acc[name]) {
                    acc[name] = { value };
                } else {
                    acc[name].value += `, ${value}`;
                }
                return acc;
            }, {});
        selectedFilters["page"] = currentPage;
        selectedFilters["dsId"] = this.dynamicFilterDsId;
        selectedFilters["pageId"] = this.dynamicFilterPageId;
        selectedFilters["selectedTab"] = this.getSelectedCategory();

        let URLAJAX = `${this.listUrl}?data=${encodeURI(JSON.stringify(selectedFilters))}&page=1 `;
        this.currentPageNumber = 2;
        await HttpClient.AsyncGetRequest(URLAJAX, this.method)
            .then(response => {
                let selectedTab = this.getSelectedCategory().toLowerCase();
                let resultData = JSON.parse(response)
                this.loadMoreButton = document.getElementById(`load-more-filter-button-${selectedTab}`);


                if (!resultData.result.trim()) {
                    this.el.querySelectorAll(".page-number-OSS")[0].innerHTML = "";
                    this.el.querySelectorAll(".page-number-OSS")[1].innerHTML = "";
                    document.querySelector(`.tab-${selectedTab} .product-list-cards`).innerHTML = "<h2 class='no-result-product'>No results found. Please try another filter.  <h2>";
                    if (this.loadMoreButton) {
                        this.loadMoreButton.style.display = "none";
                        this.el.getElementsByClassName("load-more-filter-button")[0].style.display = "none";
                    }
                }
                if (resultData.result.trim()) {
                    document.querySelector(`.tab-${selectedTab} .product-list-cards`).innerHTML = resultData.result;

                    this.el.querySelectorAll(".page-number-OSS")[0].innerHTML = "";
                    this.updateResultsLine(resultData.totalresults, resultData.totalpages);
                    if (this.loadMoreButton) {
                        if (resultData.totalpages == 1) {
                            this.loadMoreButton.style.display = "none";
                            document.getElementsByClassName("load-more-filter-button")[0].style.display = "none";

                        } else {
                            this.loadMoreButton.style.display = "block";
                            document.getElementsByClassName("load-more-filter-button")[0].style.display = "block";
                        }
                    }
                }
                const observer = lozad();
                observer.observe();
            })
            .catch((error) => console.error("Error applying filters:", error));
    }

    updateUrlWithFilters() {
        let newPathParams = this.getPathValues(this.selectedFiltersGloblal)
        const params = new URLSearchParams(window.location.search);
        params.set('filters', newPathParams);
        history.pushState(null, '', '?' + params.toString());
    }

    getPathValues(arr) {
        return arr.map(item => item.path).join('&');
    }

    async loadMoreResults() {
        var button = this.el.querySelector(".product__container");
        let selectedTab = this.getSelectedCategory().toLowerCase();
        const checkboxes = this.el.querySelectorAll(".filter-checkbox");
        this.loadMoreButton = document.getElementById(`load-more-filter-button-${selectedTab}`);
        this.totalpage = this.loadMoreButton.getAttribute("data-totalpages");

        const selectedFilters = Array.from(checkboxes)
            .filter((checkbox) => checkbox.checked)
            .map((checkbox) => ({
                name: checkbox.dataset.filterName,
                value: checkbox.value,
            })).reduce((acc, { name, value }) => {
                if (!acc[name]) {
                    acc[name] = { value };
                } else {
                    acc[name].value += `, ${value}`;
                }
                return acc;
            }, {});
        selectedFilters["page"] = this.currentPageNumber;
        selectedFilters["dsId"] = this.dynamicFilterDsId;
        selectedFilters["pageId"] = this.dynamicFilterPageId;
        selectedFilters["selectedTab"] = this.getSelectedCategory();

        let URLAJAX = `${this.listUrl}?data=${encodeURI(JSON.stringify(selectedFilters))}`;

        if (this.currentPageNumber <= this.totalpage) {
            var button = document.querySelector(`.tab-${selectedTab} .product-list-cards`);
            await HttpClient.AsyncGetRequest(URLAJAX, this.method)
                .then(card => {
                    let resultData = JSON.parse(card);
                    button.insertAdjacentHTML("beforeend", resultData.result);
                    const observer = lozad();
                    observer.observe();

                    if (resultData.totalpages == 1 || this.currentPageNumber >= resultData.totalpages) {
                        this.loadMoreButton.style.display = "none";
                        document.getElementById(`load-more-filter-button-${selectedTab}`).style.display = "none";
                    } else {
                        this.loadMoreButton.style.display = "block";
                        document.getElementById(`load-more-filter-button-${selectedTab}`).style.display = "block";
                    }
                    this.updateResultsLine(resultData.totalresults, resultData.totalpages);


                }).catch(error => {
                    console.error(error)
                });
        }
        this.currentPageNumber = this.currentPageNumber + 1;
    };

    getTabforFilters() {
        var formattedString;
        if (this.el) {
            const parentClasses = Array.from(this.el.classList);

            const tabClass = parentClasses.find(cls => cls.startsWith("tab-") && cls !== "tab-content");

            if (tabClass) {
                // Extract the dynamic part after "tab-"
                const dynamicPart = tabClass.substring(4);
                formattedString = dynamicPart.charAt(0).toUpperCase() + dynamicPart.slice(1);

                return formattedString;
            }
        }
        return formattedString;
    }

    async getFilterData() {
        const url = `${this.url}?dsId=${this.dynamicFilterDsId}&pageId=${this.dynamicFilterPageId}&tab=${this.getTabforFilters()}`;

        await HttpClient.AsyncGetRequest(url, this.method)
        .then(result => {
            result = JSON.parse(result);
            this.createFilters(result);
            this.createMobileFilters(result);
        }).catch(error => {
            console.error(error);
        });
    }
}
export default DynamicFilter;